import { FaqDto } from '../../dto/faq/faqdto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';

export interface FaqRequest extends APIRequest
{
    getFaqRequest(): FaqDto;
}

export class FaqRequestImpl extends APIRequestDtoImpl implements FaqRequest
{
    constructor(private faqData: FaqDto)
    {
        super();
    }

    getFaqRequest(): FaqDto
    {
        return this.faqData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/faq/faqrequest.tsx